import { render, staticRenderFns } from "./PageAdminPlatforms.vue?vue&type=template&id=08e03abc"
import script from "./PageAdminPlatforms.vue?vue&type=script&lang=js"
export * from "./PageAdminPlatforms.vue?vue&type=script&lang=js"
import style0 from "./PageAdminPlatforms.vue?vue&type=style&index=0&id=08e03abc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports